import React, { useState } from 'react';
import { Row, Col, Card, CardBody, Collapse, Button, Table } from 'reactstrap';
import { Form } from '@availity/form';
import { Select, Input } from '../../lib/form-field';
import '@availity/yup';
import * as yup from 'yup';
import moment from 'moment';

import * as callsActions from '../../store/calls/actions';
import { useSelector, useDispatch } from 'react-redux';
import { actualCompany } from '../../selectors/company';

import { useTranslation } from 'react-i18next';
import { Dots } from 'react-activity';

const EditNewCalls = ({ prevCalls, users }) => {
  const [sent, setSent] = useState(false);

  const loading = useSelector((state) => state.Call.loading);
  const logs = useSelector((state) => state.Call.logs);

  const company = useSelector(actualCompany);

  const dispatch = useDispatch();

  const handleEditNewCalls = (values, prevCalls) => {
    dispatch(callsActions.editNewCalls(values, prevCalls));
    setSent(true);
  };

  const { t } = useTranslation();

  return (
    <Card>
      <CardBody>
        <Form
          initialValues={{
            type: 'recall',
          }}
          validationSchema={yup.object().shape({
            type: yup.string().required(),
            appointmentDate: yup.date().when('type', {
              is: 'appointment',
              then: () => yup.date().required(),
            }),
            appointmentUserId: yup.string(),
            rcsPromoId: yup.number(),
            maxCalls: yup.number().min(1),
          })}
        >
          {({ values, isValid }) => (
            <>
              <Row>
                <Col md="3">
                  <Select
                    name="type"
                    id="type"
                    isMulti={false}
                    options={[
                      { label: t('Recall'), value: 'recall' },
                      { label: t('Appointment'), value: 'appointment' },
                    ]}
                  />
                </Col>
                <Col md="4">
                  <Collapse isOpen={values.type === 'appointment'}>
                    <Input
                      id="appointmentDate"
                      name="appointmentDate"
                      label={`${t('Appointment Date')} ${
                        values.appointmentDate &&
                        `: ${moment(values.appointmentDate).format(
                          'DD/MM/YYYY HH:mm',
                        )}`
                      }`}
                      className="form-control"
                      type="datetime-local"
                    />
                  </Collapse>
                </Col>
                <Col md="5">
                  <Collapse isOpen={values.type === 'appointment'}>
                    <Select
                      name="appointmentUserId"
                      id="appointmentUserId"
                      label={t('Operator')}
                      isMulti={false}
                      options={
                        Array.isArray(users)
                          ? [
                              { label: t('None'), value: '' },
                              ...users.map(({ id, displayName }) => ({
                                label: displayName,
                                value: id,
                              })),
                            ]
                          : []
                      }
                    />
                  </Collapse>
                </Col>
              </Row>
              {company.rcsModule && (
                <Row>
                  <Col md="4">
                    <Input
                      name="rcsPromoId"
                      id="rcsPromoId"
                      label={t('Customer Promo ID')}
                    />
                  </Col>
                  <Col md="3">
                    <Input
                      name="maxCalls"
                      id="maxCalls"
                      label={t('Max Calls to edit')}
                    />
                  </Col>
                </Row>
              )}
              <Collapse isOpen={isValid}>
                <Row className="my-2">
                  <Col md="12">
                    <h4 className="text-center">
                      {t('edit_new_calls', {
                        countCalls: prevCalls.length,
                      })}
                    </h4>
                  </Col>
                </Row>
                <Row className="my-2">
                  <Col md="12" className="text-center">
                    <Button
                      color="warning"
                      outline
                      className="waves-effect waves-light"
                      onClick={() => handleEditNewCalls(values, prevCalls)}
                      disabled={!prevCalls.length || sent}
                    >
                      <i className="bx bx-edit font-size-20 align-middle mr-2"></i>
                      {t('Edit New Calls')}
                    </Button>
                  </Col>
                </Row>
                {!!(sent && loading) && <Dots />}
                {!!(sent && logs.length) && (
                  <Row className="my-2">
                    <Col md="12">
                      <div className="table-responsive">
                        <Table className="table mb-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Call ID</th>
                              <th>Response</th>
                            </tr>
                          </thead>
                          <tbody>
                            {logs.map((log, index) => (
                              <tr
                                key={log.callId}
                                className={
                                  log.status === 200
                                    ? 'text-success font-weight-bold bg-light'
                                    : 'text-danger'
                                }
                              >
                                <th scope="row">{index}</th>
                                <td>{log.callId}</td>
                                <td>{log.response}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                )}
              </Collapse>
            </>
          )}
        </Form>
      </CardBody>
    </Card>
  );
};

export default EditNewCalls;
